var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 115,
    height: 33,
    viewBox: "0 0 115 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 0.389,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbda09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbc00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "yellow",
    d: "M7.989,1.232a2.436,2.436,0,0,1,4.235,0l7.667,13.48a2.436,2.436,0,0,1-2.117,3.64H2.44a2.436,2.436,0,0,1-2.117-3.64Z",
    transform: "translate(18.351 0) rotate(90)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.585,
    x2: 0.693,
    y2: 0.391,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01e2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01c4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.203,
    y1: 0.201,
    x2: 0.838,
    y2: 0.836,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28d781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02f076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.745,
    y1: 0.174,
    x2: 0.101,
    y2: 0.912,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2414e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e02554"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Playstore",
    transform: "translate(0 0.395)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 115,
    height: 33,
    rx: 6,
    transform: "translate(0 -0.395)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "get_it_on",
    "data-name": "get it on",
    transform: "translate(35.266 5.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M2.784,5.568A2.785,2.785,0,0,1,1.7.219,2.785,2.785,0,0,1,3.868,5.35,2.767,2.767,0,0,1,2.784,5.568Zm0-4.718A1.927,1.927,0,1,0,3.537,1,1.921,1.921,0,0,0,2.784.851Z",
    transform: "translate(22.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0,5.182V0H3.094V.619H.851V2.243H2.862v.619H.851v1.7H3.094v.619Z",
    transform: "translate(5.955 0.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M1.315,5.182V.619H0V0H3.48V.619H2.165V5.182Z",
    transform: "translate(9.899 0.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t-2",
    "data-name": "t",
    d: "M1.315,5.182V.619H0V0H3.48V.619H2.165V5.182Z",
    transform: "translate(17.479 0.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "i",
    width: 0.851,
    height: 5.182,
    transform: "translate(15.854 0.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M3.326,5.182.851,1.137V5.182H0V0H1.005l2.32,3.792V0h.851V5.182Z",
    transform: "translate(29.157 0.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g",
    transform: "translate(0 0.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1-2",
    "data-name": "Rectangle 1",
    d: "M0,0H2.329L2.306.737H0Z",
    transform: "translate(2.767 2.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_1",
    "data-name": "Oval 1",
    d: "M2.762,5.46H2.733a2.73,2.73,0,1,1,0-5.46A2.888,2.888,0,0,1,3.811.2a2.314,2.314,0,0,1,.827.556l-.533.532A1.683,1.683,0,0,0,3.51.9,2.064,2.064,0,0,0,2.756.76a1.97,1.97,0,1,0,0,3.939,2.242,2.242,0,0,0,.756-.121A1.577,1.577,0,0,0,4.1,4.21,1.633,1.633,0,0,0,4.482,3.6a2.575,2.575,0,0,0,.135-.868c0-.082,0-.164-.006-.242h.68v.027a3.015,3.015,0,0,1-.061,1.2,2.273,2.273,0,0,1-.481.907,2.341,2.341,0,0,1-.875.621A2.88,2.88,0,0,1,2.762,5.46Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "googleplay",
    transform: "translate(34.88 14.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "big_P",
    "data-name": "big P",
    transform: "translate(48.259 0.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M4.385,6.656H0V0H4.385a2.581,2.581,0,0,1,.394.112,3.425,3.425,0,0,1,.868.465,2.992,2.992,0,0,1,.868,1.008,3.7,3.7,0,0,1,.394,1.743,3.7,3.7,0,0,1-.394,1.743,2.992,2.992,0,0,1-.868,1.008,3.425,3.425,0,0,1-.868.465,2.573,2.573,0,0,1-.394.112h0ZM.851,1.61V5.182H3.827A1.35,1.35,0,0,0,4.97,4.428,2.283,2.283,0,0,0,5.182,3.4,2.283,2.283,0,0,0,4.97,2.363,1.35,1.35,0,0,0,3.827,1.61Z",
    transform: "translate(0.387 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 1.547,
    height: 10.827,
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "y",
    width: 1.547,
    height: 10.827,
    transform: "translate(56.457 0.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M6.2,7.189H4.65V6.418A2.975,2.975,0,0,1,3.8,6.9a4.606,4.606,0,0,1-1.335.268c-.08.005-.16.008-.236.008A2.361,2.361,0,0,1,.942,6.844,1.872,1.872,0,0,1,.281,6.1,2.747,2.747,0,0,1,0,4.921c0-.006,0-.015,0-.026a2.838,2.838,0,0,1,.02-.426,2.384,2.384,0,0,1,.191-.7,1.838,1.838,0,0,1,.545-.7A2.283,2.283,0,0,1,1.84,2.644a5.741,5.741,0,0,1,.841-.064,4.926,4.926,0,0,1,1.206.146A3.977,3.977,0,0,1,4.65,3V2.682a1.792,1.792,0,0,0-.4-.756,1.408,1.408,0,0,0-1.082-.44,2.89,2.89,0,0,0-.863.119,1.74,1.74,0,0,0-.525.262,1.038,1.038,0,0,0-.332.381L.165,1.486h0a1.8,1.8,0,0,1,.146-.232A2.832,2.832,0,0,1,.8.743a3.109,3.109,0,0,1,.89-.511A3.875,3.875,0,0,1,3.049,0,4.065,4.065,0,0,1,4.676.3a2.554,2.554,0,0,1,.956.706,2.476,2.476,0,0,1,.452.823A2.179,2.179,0,0,1,6.2,2.48s0,.006,0,.008ZM3.084,3.907A2.359,2.359,0,0,0,2,4.118a.972.972,0,0,0-.544.852.861.861,0,0,0,.2.671,1.08,1.08,0,0,0,.81.283,2.785,2.785,0,0,0,1.315-.372,2.126,2.126,0,0,0,.518-.4,1.1,1.1,0,0,0,.276-.495A2.857,2.857,0,0,0,4.54,4.1,6.4,6.4,0,0,0,3.084,3.907Z",
    transform: "translate(59.087 4.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y-2",
    "data-name": "y",
    d: "M1.315,9.977,2.758,6.55,0,0H1.547L3.531,4.713,5.5.037H7.046L2.862,9.977Z",
    transform: "translate(65.429 4.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e-2",
    "data-name": "e",
    d: "M3.631,7.35A3.429,3.429,0,0,1,.87,6.069,4,4,0,0,1,.213,4.886,3.59,3.59,0,0,1,0,3.714,4.134,4.134,0,0,1,.178,2.552,4.043,4.043,0,0,1,.765,1.34,3.169,3.169,0,0,1,1.838.386,3.417,3.417,0,0,1,3.474,0,3.054,3.054,0,0,1,5.08.432a3.412,3.412,0,0,1,1,.95,4.6,4.6,0,0,1,.517.95,3.6,3.6,0,0,1,.146.432L1.854,4.785a1.525,1.525,0,0,0,.342.56,1.687,1.687,0,0,0,.545.387,2.218,2.218,0,0,0,.9.179h.01a1.916,1.916,0,0,0,.763-.16A2.3,2.3,0,0,0,4.976,5.4a2.5,2.5,0,0,0,.466-.51l1.241.841h0a2.654,2.654,0,0,1-.188.252,3.962,3.962,0,0,1-.569.557,3.74,3.74,0,0,1-.953.557A3.62,3.62,0,0,1,3.631,7.35ZM3.557,1.405a1.292,1.292,0,0,0-.232.021,2.378,2.378,0,0,0-1.115.484A1.725,1.725,0,0,0,1.7,2.62a2.046,2.046,0,0,0-.132.641,1.657,1.657,0,0,0,.008.279l3.3-1.349A2.089,2.089,0,0,0,4.525,1.8a1.786,1.786,0,0,0-.418-.27A1.327,1.327,0,0,0,3.557,1.405Z",
    transform: "translate(38.051 4.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "i-2",
    "data-name": "i",
    width: 1.636,
    height: 10.805,
    transform: "translate(35.731 0.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g-2",
    "data-name": "g",
    d: "M3.536,10.646A3.479,3.479,0,0,1,2,10.308a3.368,3.368,0,0,1-1-.744,3.836,3.836,0,0,1-.538-.744,2.7,2.7,0,0,1-.161-.338L1.7,7.9a2.123,2.123,0,0,0,.4.667,1.933,1.933,0,0,0,.588.458,2.048,2.048,0,0,0,.927.208A1.953,1.953,0,0,0,4.62,8.982a1.61,1.61,0,0,0,.571-.588,2.289,2.289,0,0,0,.254-.687A2.785,2.785,0,0,0,5.5,7.161v-.74h0a1.9,1.9,0,0,1-.475.459,2.454,2.454,0,0,1-.634.316,2.968,2.968,0,0,1-.934.143,3.225,3.225,0,0,1-1.207-.248,3.631,3.631,0,0,1-.582-.3,3.671,3.671,0,0,1-.533-.415A3.553,3.553,0,0,1,.318,5.223,3.779,3.779,0,0,1,0,3.677,3.89,3.89,0,0,1,.3,2.136,3.446,3.446,0,0,1,1.1.992,3.627,3.627,0,0,1,3.476,0h.081a2.594,2.594,0,0,1,.858.142,2.46,2.46,0,0,1,.607.313A2.113,2.113,0,0,1,5.5.909V.235L7.015.248V7.065a4.188,4.188,0,0,1-.2,1.294,3.44,3.44,0,0,1-.624,1.149,3.016,3.016,0,0,1-1.081.823A3.791,3.791,0,0,1,3.536,10.646ZM3.587,1.44a1.79,1.79,0,0,0-.777.177,2,2,0,0,0-.635.484,2.286,2.286,0,0,0-.428.717,2.537,2.537,0,0,0,0,1.757,2.286,2.286,0,0,0,.428.717,2,2,0,0,0,.635.484,1.793,1.793,0,0,0,1.555,0A2,2,0,0,0,5,5.293a2.286,2.286,0,0,0,.428-.717,2.537,2.537,0,0,0,0-1.757A2.286,2.286,0,0,0,5,2.1a2,2,0,0,0-.635-.484A1.79,1.79,0,0,0,3.587,1.44Z",
    transform: "translate(27.61 4.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o-2",
    "data-name": "o",
    d: "M3.682,7.347a3.671,3.671,0,1,1,3.393-5.1,3.676,3.676,0,0,1-3.393,5.1ZM3.658,1.441a1.927,1.927,0,0,0-.806.175,2.062,2.062,0,0,0-.658.479,2.243,2.243,0,0,0-.444.71,2.4,2.4,0,0,0,0,1.738,2.243,2.243,0,0,0,.444.71,2.062,2.062,0,0,0,.658.479,1.937,1.937,0,0,0,1.611,0,2.062,2.062,0,0,0,.658-.479,2.243,2.243,0,0,0,.444-.71,2.4,2.4,0,0,0,0-1.738,2.243,2.243,0,0,0-.444-.71,2.062,2.062,0,0,0-.658-.479A1.927,1.927,0,0,0,3.658,1.441Z",
    transform: "translate(19.567 4.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o-3",
    "data-name": "o",
    d: "M3.682,7.347a3.671,3.671,0,1,1,3.393-5.1,3.676,3.676,0,0,1-3.393,5.1ZM3.658,1.441a1.927,1.927,0,0,0-.806.175,2.062,2.062,0,0,0-.658.479,2.243,2.243,0,0,0-.444.71,2.4,2.4,0,0,0,0,1.738,2.243,2.243,0,0,0,.444.71,2.062,2.062,0,0,0,.658.479,1.937,1.937,0,0,0,1.611,0,2.062,2.062,0,0,0,.658-.479,2.243,2.243,0,0,0,.444-.71,2.4,2.4,0,0,0,0-1.738,2.243,2.243,0,0,0-.444-.71,2.062,2.062,0,0,0-.658-.479A1.927,1.927,0,0,0,3.658,1.441Z",
    transform: "translate(11.601 4.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "big_g",
    "data-name": "big g",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1-3",
    "data-name": "Rectangle 1",
    d: "M0,0H4.861L4.813,1.537H0Z",
    transform: "translate(5.776 5.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_1-2",
    "data-name": "Oval 1",
    d: "M5.764,11.381H5.7A5.711,5.711,0,0,1,.448,7.9a5.673,5.673,0,0,1,.526-5.4A5.7,5.7,0,0,1,5.7,0,6.034,6.034,0,0,1,7.954.412,4.83,4.83,0,0,1,9.68,1.571L8.568,2.68a3.512,3.512,0,0,0-1.242-.813,4.313,4.313,0,0,0-1.574-.282,4.106,4.106,0,1,0,0,8.212,4.683,4.683,0,0,0,1.578-.253,3.291,3.291,0,0,0,1.234-.769A3.4,3.4,0,0,0,9.353,7.5,5.362,5.362,0,0,0,9.634,5.69c0-.171,0-.34-.012-.5h1.42v0c0,.018,0,.036,0,.054a6.277,6.277,0,0,1-.128,2.5,4.686,4.686,0,0,1-1.835,2.64,5.139,5.139,0,0,1-.993.546,5.732,5.732,0,0,1-1.117.334,6.4,6.4,0,0,1-1.207.113h0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo_play",
    transform: "translate(8.445 6.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "yellow-2",
    "data-name": "yellow",
    d: "M7.989,1.232a2.436,2.436,0,0,1,4.235,0l7.667,13.48a2.436,2.436,0,0,1-2.117,3.64H2.44a2.436,2.436,0,0,1-2.117-3.64Z",
    transform: "translate(18.351 0) rotate(90)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo_play-2",
    "data-name": "logo_play",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "blue",
    d: "M.14,0,10.951,10.745,0,21.915Z",
    transform: "translate(-0.155 -0.814)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "green",
    d: "M0,0,13.033,12.96l3.875-3.7Z",
    transform: "translate(-2.238 -3.026)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "red",
    d: "M11.789,0l5.932,5.979L0,11.958Z",
    transform: "translate(-0.993 9.931)",
    fill: "url(#linear-gradient-5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/Playstore.8260b6de004705b0505e2c4aa17874e5.svg";
export { ForwardRef as ReactComponent };